<template>
  <b-sidebar type="is-light" fullheight right :open.sync="open">
    <guides
      :guide-code="route"
      ref="guides"
    />
  </b-sidebar>
</template>

<script>
import Guides from "@/components/Guide/Guides";

export default {
  components: {
    Guides
  },
  data: () => ({
    route: ""
  }),
  computed: {
    open: {
      get() {
        return this.$store.state.guideSidebar;
      },
      set(value) {
        this.$store.state.guideSidebar = value;
      }
    }
  },
  watch: {
    $route() {
      this.route = location.pathname.substring(1);
    }
  }
};
</script>

<style>
.sidebar-content {
  width: 1070px !important;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Guide/GuideSidebar.vue